// extracted by mini-css-extract-plugin
module.exports = {"container":"FxLd6XiL","label":"UdoKe3_Q","labelContainer":"IDlqjCyT","labelRoot":"VW9NSUW_"};